'use strict';

var React = require('react');

var SvgColorsMajor = function SvgColorsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.868 12.48a4.529 4.529 0 0 0 1.132-3.176v-.19a9.998 9.998 0 0 0-1.916-5.041 10.03 10.03 0 0 0-14.53-1.7 10.005 10.005 0 0 0-3.303 9.848 10.001 10.001 0 0 0 2.566 4.744 10.02 10.02 0 0 0 4.66 2.725 19.9 19.9 0 0 0 4.007.31h1.153c.375 0 .734-.195.985-.474a1.47 1.47 0 0 0 .378-1.019 1.5 1.5 0 0 0-1.5-1.5c-.398 0-.795-.167-1.076-.448a1.5 1.5 0 0 1 1.062-2.562h3.366a4.54 4.54 0 0 0 3.016-1.517zm-6.868-8.98a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-6.5 3.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-1 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm10-4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  }));
};

exports.SvgColorsMajor = SvgColorsMajor;
